var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activityInfo)?_c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta && _vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!(_vm.$route.meta && _vm.$route.meta.keepAlive))?_c('router-view'):_vm._e(),_c('portal-target',{attrs:{"name":"nf-dialog"}}),_c('Loading'),_c('Toast'),_c('OpenApp')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }